import React, { Component, useEffect, useState } from "react";

//utils
import { get_userfullname } from "../../utils/Helper/CheckAuth";

function ContactUs() {
  function sent_contact_us() {
    //sent whatsapp message
    document.getElementById("whatsapp_link_append").innerHTML = " ";
    document.getElementById("whatsapp_link_append").innerHTML = `<a
        href="whatsapp://send?phone=+919820245424&text=Hi,%0aMyself *${get_userfullname()}*"
        data-action="share/whatsapp/share"
        target="_self"
        id="whatsapp_link_append_anchor"
      >
        Hi
      </a>`;
    document.getElementById("whatsapp_link_append_anchor").click();
    document.getElementById("whatsapp_link_append").innerHTML = " ";
  }

  return (
    <React.Fragment>
      <br />
      <br />
      <div
        className="font_sub_small_title div_but div_whatsapp center"
        onClick={sent_contact_us}
      >
        Contact Us on WhatsApp <i className="fa fa-whatsapp fa-lg" />
      </div>
      <div id="whatsapp_link_append" style={{ display: "none" }}></div>
    </React.Fragment>
  );
}

export default ContactUs;
